<template>
  <div>
    <p>Authenticating Seer...</p>
  </div>
</template>

<script>
export default {
  name: 'SalesforceAuthCallback',
  mounted() {
    if (window.opener && window.opener.oauth_callback) {
      const url = new URL(window.location.href);
      this.text = url.hash.substring(1);
      const result = {};
      const params = url.hash.substring(1).split('&');
      for (let i = 0; i < params.length; i += 1) {
        const [key, value] = params[i].split('=');
        result[key] = decodeURIComponent(value);
      }
      window.opener.oauth_callback(result);
      window.close();
    }
  },
};
</script>
